export type UnavailableFamilyTargetResult = {
  readonly success: false;
  readonly addedCount: 0;
  readonly existingCount: 0;
  readonly failedCount: number;
  readonly requestedCount: number;
  readonly queued: false;
  readonly failedParameters: string[];
  readonly failureMessages: string[];
  readonly error: string;
};

export type NonApplicableFamilyTargetResult = {
  readonly success: true;
  readonly addedCount: 0;
  readonly existingCount: 0;
  readonly failedCount: 0;
  readonly requestedCount: number;
  readonly queued: false;
};

export function buildNonApplicableFamilyTargetResult(
  parameterNames: string[]
): NonApplicableFamilyTargetResult {
  return {
    success: true,
    addedCount: 0,
    existingCount: 0,
    failedCount: 0,
    requestedCount: new Set(
      parameterNames.map((name) => name.trim()).filter(Boolean)
    ).size,
    queued: false,
  };
}

export function buildUnavailableFamilyTargetResult(input: {
  readonly parameterNames: string[];
  readonly targetLabels: string[];
}): UnavailableFamilyTargetResult {
  const parameterNames = Array.from(
    new Set(input.parameterNames.map((name) => name.trim()).filter(Boolean))
  );
  const targetLabels = Array.from(
    new Set(input.targetLabels.map((label) => label.trim()).filter(Boolean))
  );
  const targetDescription = targetLabels.length > 0
    ? targetLabels.join(', ')
    : 'the requested categories';
  const error = `No editable matching families were found for ${targetDescription}.`;

  return {
    success: false,
    addedCount: 0,
    existingCount: 0,
    failedCount: parameterNames.length,
    requestedCount: parameterNames.length,
    queued: false,
    failedParameters: parameterNames,
    failureMessages: [error],
    error,
  };
}
